import { render, staticRenderFns } from "./strategicReport.vue?vue&type=template&id=52695100&scoped=true"
import script from "./strategicReport.vue?vue&type=script&lang=js"
export * from "./strategicReport.vue?vue&type=script&lang=js"
import style0 from "./strategicReport.vue?vue&type=style&index=0&id=52695100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52695100",
  null
  
)

export default component.exports